const sessionKey = 'new_failure_file_set'

export interface WizardData {
  setId: string | undefined
  description: string
}

const ID = (machineId: string): string => {
  return sessionKey+machineId
}

export const LoadWizardData = (machineId: string): WizardData => {
  var json = sessionStorage.getItem(ID(machineId))
  if(!json) {
    return CleanWizardData(machineId)
  }
  const data = JSON.parse(json)
  return {
    description: data.description || '',
    setId: data.setId
  }
}

export const SaveWizardData = (machineId: string, data: WizardData) => {
  sessionStorage.setItem(ID(machineId), JSON.stringify({
    description: data.description || '',
    setId: data.setId
  }))
}
 
export const CleanWizardData = (machineId: string): WizardData => {
  var empty: WizardData = {
    description: '',
    setId: undefined
  }
  SaveWizardData(machineId, empty)
  return empty
}